import Onboard from '@web3-onboard/core';
import injectedModule from '@web3-onboard/injected-wallets';
import walletConnectModule from '@web3-onboard/walletconnect';
import { ethers } from 'ethers';
import axios from 'axios';

const wcV2InitOptions = {
  projectId: '17b45c3e6103ac45a22395081d3f563b', 
  requiredChains: [1], 
}
const walletConnect = walletConnectModule(wcV2InitOptions)
class WalletAuthController {
    constructor() {
        this.onboard = null;
        this.statusEl = null;
        this.inviteCodeInput = null;
    }

    init(config) {
        this.mode = config.mode; // 'auth' or 'connect'
        this.statusEl = document.getElementById(config.statusElementId);
        this.inviteCodeInput = document.getElementById(config.inviteCodeElementId);

        this.onboard = Onboard({
            wallets: [injectedModule(),walletConnect],
            chains: [{ id: '0x1', token: 'ETH', label: 'Ethereum Mainnet', rpcUrl: 'https://mainnet.infura.io/v3/2d900b08fccc41c991cee8aacee99e64' }],
            appMetadata: { name: 'SGNL', description: 'SGNL Wallet Authentication' }
        });

        document.getElementById(config.buttonId)?.addEventListener('click', () => this.runFlow());
    }

    async runFlow() {
        this.updateStatus('Connecting to wallet...', 'muted');
        try {
            // 1. Connect Wallet
            const wallets = await this.onboard.connectWallet();
            if (!wallets[0]) throw new Error('Wallet connection cancelled.');
            
            const connectedWallet = wallets[0];
            const address = connectedWallet.accounts[0].address;

            // 2. Get Message from Backend
            this.updateStatus('Requesting signature message...', 'muted');
            const messageResponse = await this.getMessageFromApi(address);
            const messageToSign = messageResponse.data.message;

            // 3. Sign Message
            this.updateStatus('Please sign the message in your wallet.', 'muted');
            const ethersProvider = new ethers.BrowserProvider(connectedWallet.provider, 'any');
            const signer = await ethersProvider.getSigner();
            const signature = await signer.signMessage(messageToSign);

            // 4. Verify Signature with Backend
            this.updateStatus('Verifying signature...', 'muted');
            const verifyResponse = await this.verifySignatureWithApi(address, signature);
            
            this.handleSuccess(verifyResponse.data);

        } catch (error) {
            this.handleError(error);
            const [primaryWallet] = this.onboard.state.get().wallets;
            if (primaryWallet) await this.onboard.disconnectWallet({ label: primaryWallet.label });
        }
    }

    getMessageFromApi(address) {
        if (this.mode === 'auth') {
            const inviteCode = this.inviteCodeInput ? this.inviteCodeInput.value : '';
            return axios.post('/api/auth/message', { address, invite_code: inviteCode });
        } else { // 'connect' mode
            return axios.get('/api/user/wallets/signature-message');
        }
    }

    verifySignatureWithApi(address, signature) {
        if (this.mode === 'auth') {
            return axios.post('/api/auth/verify', { address, signature });
        } else { // 'connect' mode
            return axios.post('/api/user/wallets/verify', { address, signature });
        }
    }

    handleSuccess(data) {
        if (this.mode === 'auth') {
            this.updateStatus('Success! Redirecting to the app...', 'success');
            // --- START: THE FIX ---
            // Redirect to the simple '/app' path.
            setTimeout(() => {
                window.location.href = '/app';
            }, 1500);
            // --- END: THE FIX ---
        } else { // 'connect' mode
            this.updateStatus(data.message || 'Wallet connected successfully!', 'success');
            const walletsList = document.getElementById('wallets-list');
            const newWalletLi = document.createElement('li');
            newWalletLi.className = 'py-3 flex items-center justify-between';
            newWalletLi.innerHTML = `<span class="text-sm text-text-base font-mono">${data.wallet.wallet_address}</span><span class="text-xs font-semibold px-2 py-0.5 rounded-full bg-secondary text-text-muted">Ethereum</span>`;
            walletsList.appendChild(newWalletLi);
            document.getElementById('no-wallets-message')?.remove();
        }
    }

    handleError(error) {
        const errorMessage = error.response?.data?.message || error.message || 'An unknown error occurred.';
        this.updateStatus(errorMessage, 'error');
    }

    updateStatus(message, type) {
        if (!this.statusEl) return;
        this.statusEl.textContent = message;
        const typeMap = {
            'error': 'text-danger',
            'success': 'text-success',
            'muted': 'text-text-muted',
        };
        this.statusEl.className = `mt-2 text-sm ${typeMap[type] || 'text-text-muted'}`;
    }
}

export const walletAuthController = new WalletAuthController();